'use strict';

class dunningService {
  constructor($http) {
    this.$http = $http;
  }

  list(params = {}) {
    return this.$http.get(`/dunnings/dunnable`, {
      params: params
    });
  }

  send(params) {
    return this.$http.post(`/dunnings/mass`, params);
  }

  fees(invoiceNumber) {
    return this.$http.get(`/dunnings/fees/calculate?invoiceNumber=${invoiceNumber}`);
  }

  get(number) {
    return this.$http.get(`/dunnings/${number}`);
  }

  issue(params) {
    return this.$http.post(`/dunnings/`, params);
  }

  sendAgain(number, params) {
    return this.$http.post(`/dunnings/${number}/send`, params);
  }
}

dunningService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('dunningService', dunningService);
